import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e054ddca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter data with computed properties. Compare this code with the code from ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("filtering with computed properties")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Sort titles by: ")

import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = ref(["title", "rating"]);
const ratingsInfo = ref([
        { title: `White Chicks`, rating: 82 },
        { title: `Grey's Anatomy`, rating: 98 },
        { title: `Prison Break`, rating: 98 },
        { title: `How I Met Your Mother`, rating: 94 },
        { title: `Supernatural`, rating: 95 },
        { title: `Breaking Bad`, rating: 97 },
        { title: `The Vampire Diaries`, rating: 91 },
        { title: `The Walking Dead`, rating: 98 },
        { title: `Pretty Little Liars`, rating: 96 },
        { title: `Once Upon a Time`, rating: 98 },
        { title: `Sherlock`, rating: 95 },
        { title: `Death Note`, rating: 77 },
        { title: `Naruto`, rating: 88 },
        { title: `Arrow`, rating: 96 },
        { title: `Black Mirror`, rating: 80 },
        { title: `The Originals`, rating: 74 },
        { title: `The 100`, rating: 97 },
        { title: `Masha and the Bear`, rating: 81 },
        { title: `Hunter X Hunter`, rating: 57 },
        { title: `Marvel's Luke Cage`, rating: 95 },
        { title: `Marvel's Iron Fist`, rating: 98 }
      ]);
const sortLowest = () => {
  ratingsInfo.value.sort((a, b) => a.rating > b.rating ? 1 : -1);
};
const sortHighest = () => {
  ratingsInfo.value.sort((a, b) => a.rating < b.rating ? 1 : -1);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _hoisted_2,
      _createVNode(_component_router_link, { to: "/computed-properties" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", null, [
      _hoisted_4,
      _createElementVNode("button", { onClick: sortLowest }, "Lowest Rated"),
      _createElementVNode("button", { onClick: sortHighest }, "Highest Rated")
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (key) => {
            return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(key), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratingsInfo.value, (entry) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: entry.title
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (key) => {
              return (_openBlock(), _createElementBlock("td", { key: key }, _toDisplayString(entry[key]), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})